module.exports = __webpack_public_path__ + "img/20200110155705151.9631f8d8.jpg";